export default __webpack_public_path__ + "static/rainbow-00de893d8c10b8275eec4e6e5ab761d7.png";